import { useEffect } from 'react';
import { useNotificationStore } from '@/notifications/store';

/**
 * Single writer for active Plan trip notification scope.
 * Keep ownership in Plan screen selection state.
 */
export function useActivePlanTripBinding(selectedTripId: string | null) {
  useEffect(() => {
    useNotificationStore.getState().setActivePlanTripId(selectedTripId ?? undefined);
    return () => {
      useNotificationStore.getState().setActivePlanTripId(undefined);
    };
  }, [selectedTripId]);
}
